import { Row, Col, Pagination, Button, Form } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
// import { toast } from "react-toastify";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export function Table({
  columns,
  data,
  setPageno,
  pagecount,
  show,
  pageno,
  color = "#000",
  rowsPerPage,
  getRowProps = (row) => ({}),
}) {
  // console.log(
  //   "KKKKKKKK<<",
  //   "columns",
  //   columns,
  //   "data",
  //   data,
  //   "setPageno",
  //   setPageno,
  //   "pagecount",
  //   pagecount,
  //   "show",
  //   show,
  //   pageno,
  // );

  // console.log("pagination", pagecount);

  const [pagenumber, setPagenumber] = useState(1);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: pageno ? pageno - 1 : 0,
        pageSize: rowsPerPage ? rowsPerPage : 10,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    const newPage = pageIndex + 1;
    setPagenumber(newPage);
    if (!pagecount) {
      setPageno(newPage);
    }
  }, [pageIndex]);
  // console.log(pageCount,"page count",canPreviousPage,canNextPage);
  // if (!data || data.length === 0) {
  //   return <div>No Record Found</div>;
  // }

  return (
    <div className="mt-4 table-design">
      {/* <Row className="">
        <Col className="">
          <div className="d-flex ac-je ps-2 mt-2">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          </div>
        </Col>
      </Row> */}
      <BTable
        size="sm"
        responsive
        {...getTableProps()}
        className=" table-border table mb-0"
        //  variant="dark"
      >
        <thead className="">
          {headerGroups.map((headerGroup, ind) => (
            <tr
              className="nowrap "
              {...headerGroup.getHeaderGroupProps()}
              key={ind}
            >
              {headerGroup.headers.map((column, indx) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th
                  className="px-3 text-start py-2  "
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                  style={{ border: "none" }}
                >
                  <h4
                    className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3"
                    // style={{textAlign:column.render("Header")=="Status"?"center":"left"}}
                  >
                    {column.render("Header")}
                  </h4>
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        {!data || data.length === 0 ? (
          <tbody {...getTableBodyProps()}>
            <tr>
              <td
                colSpan={columns.length}
                style={{ textAlign: "left", padding: "12px" }}
              >
                No Record Found
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  className=" text-start  f2"
                  {...row.getRowProps()}
                  {...getRowProps(row)}
                  key={i}
                >
                  {row.cells.map((cell, ind) => {
                    const rowProps = getRowProps(row);
                    return (
                      <td
                        style={{
                          border: "none",
                          color: color,
                          backgroundColor: rowProps?.style?.backgroundColor,
                        }}
                        className="fs-sm-10 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 px-3 py-2 mt-2 gray2 list-data"
                        t-2
                        {...cell.getCellProps()}
                        key={ind}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        )}
      </BTable>
      {show && pagecount && (
        <Row className="justify-content-between table-show my-2 px-4 w-100">
          <Col>
            <div className="d-flex align-items-center ">
              <p className="px-1 mb-0">Total Pages</p>

              <Pagination className="gap-1 pointer m-0">
                <input
                  type="number"
                  className="btn"
                  // className="form-control ml-2  p-1 py-1 text-center"
                  value={pagecount?.last_page || 0}
                  readOnly
                />
              </Pagination>
            </div>
          </Col>
          <Col>
            <div className="d-flex align-items-center justify-content-end">
              <p className="px-1 mb-0">The Page on</p>

              <Pagination className="gap-1 pointer m-0">
                <button
                  // style={{width:32,height:32}}
                  className="btn"
                  onClick={() => {
                    setPageno(
                      pagecount?.current_page == 1
                        ? pagecount?.current_page
                        : pagecount?.current_page - 1,
                    );
                  }}
                >
                  <KeyboardArrowLeftIcon className="page-left-arrow" />
                </button>
                <input
                  type="number"
                  className="btn"
                  // className="form-control ml-2  p-1 py-1 text-center"
                  value={pagecount?.current_page}
                  onChange={(e) => {
                    setPageno(
                      e.target.value > pagecount?.last_page
                        ? pagecount?.last_page
                        : e.target.value,
                    );
                  }}
                />
                <button
                  className="btn"
                  // className="form-control ml-2  p-1 py-1 text-center"
                  onClick={() => {
                    setPageno(
                      pagecount?.current_page >= pagecount?.last_page
                        ? pagecount?.last_page == 0
                          ? 1
                          : pagecount?.last_page
                        : pagecount?.current_page + 1,
                    );
                    if (pagecount?.current_page >= pagecount?.last_page)
                      toast.info("No More Pages Available...");
                  }}
                >
                  <KeyboardArrowRightIcon className="page-left-arrow" />
                </button>
              </Pagination>
            </div>
          </Col>
          {/* <Col>
                        <span >
                            <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">
                                {pagecount?.last_page}
                            </button>
                        </span>
                    </Col> */}
        </Row>
      )}
      {show && !pagecount && (
        <Row className="justify-content-between table-show my-2 px-4 w-100">
          <Col className="d-flex ac-je  ">
            <p className="px-1 mb-0">The Page on</p>
            <Pagination className="gap-1 pointer mb-0">
              <Pagination.Prev
                onClick={() => {
                  previousPage();
                  if (canPreviousPage) {
                    setPageno(pageno - 1);
                  }
                }}
                // disabled={!canPreviousPage}
              />
              {/* <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">1</button> */}
              <input
                type="number"
                style={{ width: "30px" }}
                className="form-control ml-2  p-1 py-1 text-center"
                value={pagenumber}
                onChange={(e) => {
                  if (!Number(e.target.value)) {
                    setPagenumber(e.target.value);
                    return;
                  }
                  if (e.target.value > pageCount) {
                    gotoPage(pageCount - 1);
                    setPagenumber(pageCount);
                    return;
                  }
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                  setPagenumber(e.target.value);
                }}
              />

              <Pagination.Next
                onClick={() => {
                  nextPage();
                  if (canNextPage) {
                    setPageno(pageno + 1);
                  }
                }}
                // disabled={!canNextPage}
              />
            </Pagination>
          </Col>
          {/* <Col>
            <span className="d-flex align-items-center justify-content-end">
              <p className="px-1 mb-0">No.Of.Pages</p>
              <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">
                {pageCount}
              </button>
            </span>
          </Col> */}
          {/* <Col>
          <span className="d-flex align-items-center justify-content-end">
            <input
              type="number"
              className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control  text-center"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "40px" }}
            />
            <p className="px-1 mb-0">Page</p>{" "}
          </span>
        </Col> */}
        </Row>
      )}
    </div>
  );
}
